var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgchartfill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.755 14.792H20.3016V10.8286H13.4183V9.21529H15.545C16.2316 9.21529 16.7883 8.65862 16.7883 7.97529V1.24195C16.7883 0.55862 16.2316 0.00195312 15.545 0.00195312H8.45162C7.76496 0.00195312 7.20829 0.55862 7.20829 1.24195V7.97195C7.20829 8.65529 7.76496 9.21195 8.45162 9.21195H10.5983V10.8253H3.69496V14.7886H1.24162C0.554958 14.7886 -0.00170898 15.3453 -0.00170898 16.0286V22.7586C-0.00170898 23.442 0.554958 23.9986 1.24162 23.9986H8.67163C9.35829 23.9986 9.91496 23.442 9.91496 22.7586V16.0286C9.91496 15.3453 9.35829 14.7886 8.67163 14.7886H6.18496V13.3053H17.815V14.7886H15.3283C14.6416 14.7886 14.085 15.3453 14.085 16.0286V22.7586C14.085 23.442 14.6416 23.9986 15.3283 23.9986H22.7583C23.445 23.9986 24.0016 23.442 24.0016 22.7586V16.0286C24.0016 15.3453 23.445 14.7886 22.7583 14.7886L22.755 14.792Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgchartfill);
export default __webpack_public_path__ + "static/media/orgchartfill.b6000de8fa317ddabc521ff9bb7a3b82.svg";
export { ForwardRef as ReactComponent };